module.exports = __webpack_public_path__ + "img/旅遊日語.c867c186.png";